import React from 'react';
import { HomeworkItem, Class } from '@homework-app/shared';
import PeriodBox from './PeriodBox';

interface PeriodsContainerProps {
  homeworkData: { [period: number]: HomeworkItem[] };
  classes: Class[];
  onAddHomework: (period: number, text: string) => void;
  onUpdateHomework: (id: string, text: string, completed: boolean) => void;
  onDeleteHomework: (id: string) => void;
  onPhotoUpload: (homeworkId: string, file: File) => void;
  onPhotoClick: (photoSrc: string) => void;
}

const PeriodsContainer: React.FC<PeriodsContainerProps> = ({
  homeworkData,
  classes,
  onAddHomework,
  onUpdateHomework,
  onDeleteHomework,
  onPhotoUpload,
  onPhotoClick
}) => {
  // Only show enabled classes
  const enabledClasses = classes.filter(cls => cls.enabled);

  return (
    <div className="periods-container">
      {enabledClasses.map(cls => (
        <PeriodBox
          key={cls.period}
          period={cls.period}
          subject={cls.subject}
          periodName={`${cls.subject} - ${cls.teacher}`}
          homeworkItems={homeworkData[cls.period] || []}
          onAddHomework={onAddHomework}
          onUpdateHomework={onUpdateHomework}
          onDeleteHomework={onDeleteHomework}
          onPhotoUpload={onPhotoUpload}
          onPhotoClick={onPhotoClick}
        />
      ))}
    </div>
  );
};

export default PeriodsContainer;
